import { render } from "./InvoiceTableLoading.vue?vue&type=template&id=16ed3e63&scoped=true"
import script from "./InvoiceTableLoading.vue?vue&type=script&lang=js"
export * from "./InvoiceTableLoading.vue?vue&type=script&lang=js"

import "./InvoiceTableLoading.vue?vue&type=style&index=0&id=16ed3e63&lang=scss&scoped=true"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ed3e63"]])

export default __exports__